var createI18nText = function (text) {
    return text;
};
export default createI18nText;
//# sourceMappingURL=createI18nText.js.map